interface ITableDataSourceItem<TModel> {
    Model: TModel;
    IsSelected?: boolean;
    IsInFocus?: boolean;
    Name: string;
}

class TableDataSourceItem<TModel> implements ITableDataSourceItem<TModel> {
    public Model: TModel;
    public IsSelected: boolean;
    public IsInFocus: boolean;
    public Name: string;

    constructor(model: TModel) {
        this.Model = model;
    }
}

export { ITableDataSourceItem, TableDataSourceItem };
